/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';

import { useAction } from '../../../Common/hooks';
import { oneSecond } from '../../../Common/constants';
import { getAggregatorOptions, getPayerOptions } from '../../services';
import { setTaskFilters } from '../../actions';
import { getTaskFilters } from '../../selectors';
import { taskFiltersInitialState } from '../../reducers';
import { dropDownDefault } from '../../services/constants';

const useTaskFilterBar = () => {
  const storeFilters = useSelector(getTaskFilters);
  const setStoreFilters = useAction(setTaskFilters);
  const debouncedFilterChange = useCallback(debounce(setStoreFilters, oneSecond), []);
  const [aggregatorOptions, setAggregatorOptions] = useState(dropDownDefault);
  const [payerOptions, setPayerFilterOptions] = useState([]);
  const [showResetButton, setShowResetButton] = useState(false);
  const [filters, setFilters] = useState({ ...storeFilters });

  useEffect(() => {
    const callFilterOptions = async () => {
      const aggregatorFilterOptions = await getAggregatorOptions();

      setAggregatorOptions(aggregatorFilterOptions);
    };

    callFilterOptions();

    return () => setStoreFilters({ ...taskFiltersInitialState });
  }, []);

  useEffect(() => {
    debouncedFilterChange(filters);
    setShowResetButton(!isEqual(filters, taskFiltersInitialState));
  }, [filters]);

  const updatePayerFilterOptions = async value => {
    const payersOptionsPerAggregatorID = await getPayerOptions(value);
    setPayerFilterOptions(payersOptionsPerAggregatorID);
  };

  const handleFilterChanges =
    filterName =>
    ({ target: { value } }) => {
      let filter = { [filterName]: value };

      if (filterName === 'aggregatorID') {
        setPayerFilterOptions([]);
        updatePayerFilterOptions(value);
        filter = { ...filter, payerID: '' };
      }

      setFilters({
        ...filters,
        ...filter,
      });
    };

  const handleResetFilter = () => {
    setFilters({ ...taskFiltersInitialState });
    setPayerFilterOptions([]);
  };

  return {
    aggregatorOptions,
    payerOptions,
    showResetButton,
    handleFilterChanges,
    handleResetFilter,
    filters,
  };
};

export default useTaskFilterBar;
